import { createAction } from '@gef-ui/utils/fsaActions';
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { formStateActions } from '../../constants';
import { composeAction } from '../../utils';
/**
 * Update form state for given form
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateFormState('form')('Ahoj')
 *
 */ export const updateFormState = memoizeWithIdentity((formName)=>createAction(composeAction(formName, formStateActions.UPDATE_FORM_STATE)));
